import * as React from "react"

const FilePreviewIcon = (props: any) => (
    <svg
        width={104}
        height={104}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={104} height={104} rx={8} fill="#FAFBFC" />
        <rect width={104} height={104} rx={8} fill="#4D3951" fillOpacity={0.11} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M58.625 26.907a5.028 5.028 0 0 0-3.632-1.573h-18.34c-2.813 0-5.115 2.4-5.115 5.333v42.667c0 2.933 2.276 5.333 5.09 5.333h30.72c2.813 0 5.115-2.4 5.115-5.333V43.547c0-1.413-.537-2.773-1.51-3.76l-12.328-12.88Zm-4.067 14.427v-12l14.068 14.667h-11.51c-1.407 0-2.558-1.2-2.558-2.667Zm-15.383 15.61v11.055H41.2v-4.608h3.268v-1.568h-3.268v-3.312h3.76l.215-1.568h-6.001Zm9.534 11.055V56.943h-2.026V68h2.026Zm4.511-11.056v9.328h4.252L57.242 68h-6.047V56.943h2.025Zm11.677 1.568.215-1.568h-6.154V68h6.216v-1.584h-4.19v-3.248h3.407V61.6h-3.407v-3.088h3.913Z"
            fill="#4D3951"
        />
    </svg>
)

export default FilePreviewIcon
